import { Table, TableHead, TableRow, TableCell, TableBody, TextField, IconButton, Button, Box } from '@mui/material';
import { Delete, Add } from '@mui/icons-material';

export interface EditableColumn {
  key: string;
  label: string;
  type?: 'text' | 'number';
  width?: number | string;
  readOnly?: boolean;
}

interface Props<T extends Record<string, unknown>> {
  columns: EditableColumn[];
  rows: T[];
  onChange: (rows: T[]) => void;
  newRow: () => T;
  disabled?: boolean;
}

/** Generic editable grid used for template / rate-card / BOQ line-item editing. */
export function EditableItemsTable<T extends Record<string, unknown>>({ columns, rows, onChange, newRow, disabled }: Props<T>) {
  const update = (idx: number, key: string, value: string, type?: string) => {
    const next = rows.map((r, i) => (i === idx ? { ...r, [key]: type === 'number' ? Number(value) : value } : r));
    onChange(next);
  };
  return (
    <Box>
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map((c) => <TableCell key={c.key} style={{ width: c.width, fontWeight: 600 }}>{c.label}</TableCell>)}
            {!disabled && <TableCell />}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <TableRow key={idx}>
              {columns.map((c) => (
                <TableCell key={c.key}>
                  {c.readOnly ? (
                    <span>{String(row[c.key] ?? '')}</span>
                  ) : (
                    <TextField
                      variant="standard"
                      type={c.type ?? 'text'}
                      value={row[c.key] ?? ''}
                      onChange={(e) => update(idx, c.key, e.target.value, c.type)}
                      disabled={disabled}
                      fullWidth
                    />
                  )}
                </TableCell>
              ))}
              {!disabled && (
                <TableCell>
                  <IconButton size="small" color="error" onClick={() => onChange(rows.filter((_, i) => i !== idx))}><Delete fontSize="small" /></IconButton>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {!disabled && <Button startIcon={<Add />} size="small" sx={{ mt: 1 }} onClick={() => onChange([...rows, newRow()])}>Add row</Button>}
    </Box>
  );
}
